import { Bookmark, Clock, MapPin, Users } from "lucide-react";
import { Link } from "react-router-dom";
import type { MeetupDate } from "@/data/demo";

export function DateCard({ date }: { date: MeetupDate }) {
  return (
    <article className="date-card">
      <div className="date-block">
        <span>{date.weekday.slice(0, 3)}</span>
        <span className="date-day">{date.day}</span>
        <span className="date-month">{date.month}</span>
      </div>
      <div className="date-body">
        <Link to={`/dates/${date.id}`}>
          <h3>{date.title}</h3>
        </Link>
        <div className="date-meta">
          <span>
            <Clock size={14} /> {date.time}
          </span>
          <span>
            <MapPin size={14} /> {date.location.split(" · ")[0]}
          </span>
        </div>
        <div className="date-footer">
          <span className="date-status">{date.status}</span>
          <span>
            <Users size={14} /> {date.places}
          </span>
        </div>
      </div>
      <button className="save-listing" aria-label={`Save Date ${date.title}`}>
        <Bookmark size={18} />
      </button>
    </article>
  );
}
